var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPokeball(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "207.558 144.767 108.72 111.047",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(241, 75, 61)",
      strokeWidth: 4,
      stroke: "rgb(61, 65, 69)"
    },
    cx: 262.5,
    cy: 199.71,
    r: 51.453,
    transform: "matrix(-0.999848, -0.017452, 0.017452, -0.999848, 521.476501, 403.947876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 213.095 249.384 C 213.279 235.657 218.946 223.23 227.956 214.234 C 236.968 205.239 249.325 199.674 262.891 199.674 C 276.456 199.674 288.664 205.239 297.433 214.234 C 306.203 223.23 311.536 235.657 311.352 249.384",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(255, 255, 255)"
    },
    transform: "matrix(-0.999848, -0.017452, 0.017452, -0.999848, 520.493164, 453.600159)"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      paintOrder: "fill",
      strokeWidth: 4,
      stroke: "rgb(61, 65, 69)"
    },
    x1: 274.421,
    y1: 199.95,
    x2: 313.956,
    y2: 199.95,
    transform: "matrix(-0.999848, -0.017452, 0.017452, -0.999848, 584.842651, 405.003723)"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      paintOrder: "fill",
      strokeWidth: 4,
      stroke: "rgb(61, 65, 69)"
    },
    x1: 210.758,
    y1: 199.685,
    x2: 247.386,
    y2: 199.104,
    transform: "matrix(-0.999848, -0.017452, 0.017452, -0.999848, 454.629272, 402.756409)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.999847, -0.017452, 0.017452, -0.999847, 443.54657, 471.202637)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      paintOrder: "fill",
      stroke: "rgb(61, 65, 69)",
      fill: "rgb(61, 65, 69)"
    },
    transform: "matrix(0.741278, 0, 0, 0.726744, -318.473877, -98.401161)",
    cx: 681,
    cy: 505,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 0,
      fill: "rgb(255, 245, 245)",
      stroke: "rgb(61, 65, 69)"
    },
    transform: "matrix(1, 0, 0, 1.000003, -525.663025, -267.686707)",
    cx: 712,
    cy: 536,
    r: 10.757
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(61, 65, 69)"
    },
    cx: 186.443,
    cy: 268.532,
    r: 5.232
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokeball);
export default __webpack_public_path__ + "static/media/pokeball.174f332a46f03d97adfb7e8071f7c818.svg";
export { ForwardRef as ReactComponent };